import React from 'react';
import HeroArea from '../components/project/ProjectHero';
import NextProjectButton from '../components/project/NextProjectButton';
import hero from '../assets/images/cover-image_proximity.jpg'
import lazy from '../assets/compressed-images/cover-image_proximity.png'
import CloseProject from 'components/shared/CloseProject';
import { IDesktopScreen } from 'components/project/ProjectShowcaseDesktop';
import IShowCaseTypes from 'models/IShowCaseTypes';
import ProjectShowCaseMobile, { IScreenMobile } from 'components/project/ProjectShowcaseMobile';
import ProjectShowCaseDesktop from 'components/project/ProjectShowcaseDesktop';
import ProjectShowCaseText, { IText } from 'components/project/ProjectShowCaseText';

import DesktopProximity from '../assets/images/proximity/proximity-desktop.mp4'

import ProximityTablet from "../assets/images/proximity/proximity-tablet.mp4";
import ProjectIntro from 'components/project/ProjectIntro';
import { IProjectList } from 'components/project/ProjectList';


const desktop: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "proximity.nl/dashboard", src: DesktopProximity, alt: 'Proximity desktop account for managing your leads' };
const tablet: IScreenMobile = { type: IShowCaseTypes.mobile, src: ProximityTablet, alt: 'Proximity app for during a event' };

function Proximity() {
    const title: string = "Proximity";
    const summary: string = "A platform to increase connection, leads and performance during a networking event.";
    const projectLists: Array<IProjectList> = [{
        nameOfList: 'Category',
        items: ["Design", "UX Design", "Branding", "Mobile", "Desktop"]
    },
    {
        nameOfList: 'Technology',
        items: ["Invision", "Sketch", "Illustrator"]
    }];
    const textApp: IText = {
        type: IShowCaseTypes.text,
        text: {
            title: "Proximity App",
            paragraphs: ["Gain insights about your target audience in your direct vicinity. With the app you connect on the spot and review your connections for later manage."]
        }
    }
    const textDesktop: IText = {
        type: IShowCaseTypes.text,
        text: {
            title: "Proximity Desktop",
            paragraphs: ["Ideal to find or plan your event, review your connections/leads and to keep track of your performance on events you visited."]
        }
    }

    const content: Array<Array<IScreenMobile | IText | IDesktopScreen>> = [
        [textApp],
        [tablet],
        [textDesktop],
        [desktop],

    ];

    const showCase = content.map((item: IScreenMobile[] | IDesktopScreen | IText | any, index: number) => {
        switch (item[0].type) {
            case IShowCaseTypes.mobile:
                return <ProjectShowCaseMobile key={index} screens={item} />;
            case IShowCaseTypes.desktop:
                return <ProjectShowCaseDesktop key={index} screen={item[0]} />;
            case IShowCaseTypes.text:
                return <ProjectShowCaseText key={index} text={item[0].text} />
        }
    });



    return (
        <div>
            <CloseProject />
            <HeroArea placeholder={lazy} hero={hero} />
            <ProjectIntro summary={summary} projectLists={projectLists} title={title} />
            {showCase}
            <NextProjectButton />

        </div>
    );
};

export default Proximity